"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "9", height: "9", viewBox: "0 0 9 9", className: "Icon close-x-small", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "#FFF", fillRule: "evenodd" },
            _react2.default.createElement("path", { d: "M7.496.592a.854.854 0 0 1 1.21.002c.335.335.332.88.002 1.21l-6.49 6.49a.854.854 0 0 1-1.21-.002.859.859 0 0 1-.002-1.21l6.49-6.49z" }),
            _react2.default.createElement("path", { d: "M1.006 1.804a.854.854 0 0 1 .002-1.21.859.859 0 0 1 1.21-.002l6.49 6.49a.854.854 0 0 1-.002 1.21.859.859 0 0 1-1.21.002l-6.49-6.49z" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/close-x-small.js
// module id = 1789
// module chunks = 0